/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
export const i18nEnUs = {
    false: "No",
    true: "Yes",
    back: 'Back',
    continue: 'Next',
    type: 'Type',
    edit: 'Edit',
    globalShortcuts: 'Global Shortcuts',
    timeClock: 'Time tracking',
    reportBug: "Report bug",
    CTRLM: 'CTRL + M',
    CTRLO: 'CTRL + O',
    CTRLB: 'CTRL + B',
    ImportCsv: "Import CSV",
    ExportCsv: "Export CSV",
    ImportExcel: "Import Excel",
    ExportExcel: "Export Excel",
    Create: "Create",
    Show: "Show",
    Edit: "Edit",
    Copy: "Copy",
    Delete: "Delete",
    Close: "Close",
    Cancel: "Cancel",
    Update: "Update",
    Redo: "Redo",
    Undo: "Undo",
    Reset: "Reset",
    attachment: 'Attachment',
    onThisPage: 'On this page',
    accountCompanyInfoHeader: 'Company Information',
    accountCompanyAddCompany: 'Add new Company',
    accountEmployeeGroupConfirmed: 'Verified user',
    accountEmployeeGroupNotConfirmed: 'Non Verified User',
    accountEmployeeAddUser: 'Add new User',
    accountGeneralHeader: 'Account Data',
    accountSaveBottomBar: 'Save changes',
    accountPersonalInfoHeader: 'Personal Data',
    accountPersonalSignature: "Signature",
    accountPersonalUploadSignature: "Upload Signature",
    companyDetailsUploadLogo: "Upload Logo",
    accountNewDepartment: 'New department',
    accountConfirmationHeader: 'Account successfully confirmed',
    accountConfirmationContent: 'You have Recieved a Confirmation Email',
    accountConfirmationSetNewPasswordHeader: 'Please enter a Password for your new Account',
    accountConfirmationContinueToHome: 'Continue to the Customer Portal',
    userIsVerifiedHint: 'E-Mail-Address confirmed',
    userHasSignatureHint: 'Signature stored digitally',
    addComingSoon: 'Feature to update screenshots coming soon!',
    addFeatureDesc: 'Feature description',
    addFeatureHeader: '{{index}}. feature:',
    addFeatureTitle: 'Feature title',
    productCostTrendYear: 'Year',
    productCostTrendCosts: 'Costs in €',
    addFinish: 'Create {{prodName}}',
    addFinishEdit: 'Update {{prodName}}',
    addLongDesc: 'Long description for {{langCode}}',
    addName: 'Name of the new product',
    addNameEdit: 'Name of the product',
    addPaymentInterval: 'Payment interval (in months)',
    addPricingFeature: 'Billing costs / Feature',
    addProductDiscounts: "Discounts / From license",
    addProductDiscountsEnabled: "Discounts Enabled",
    addPrice: 'Price',
    addProductImage: 'Chose a product image',
    addProductUniversalScreenshot: 'Language Independent Images',
    selectLanguage: "Select language",
    addShortDesc: 'Short description for {{langCode}}',
    addStepFeature: 'Features',
    addStepGeneral: 'General information',
    addStepScreenshot: 'Screenshots',
    addAttachments: 'Attachments',
    addStepLicenseAgreements: 'License agreements',
    addStepPricing: 'Pricing & Discounts',
    pricingFeatures: "Feature overview",
    addressAddNewAddress: 'Add new address',
    addressEditAddress: 'Edit address',
    addressCreateHelpTextPre: "Here you can view or change your company address. Addresses are mostly used as delivery addresses and/or billing addresses.",
    addressCreateHelpTextAfter: "After saving, the address is immediately updated in the overview.",
    addressFederalState: 'Federal state',
    addressLand: 'Country',
    addressNumber: 'House No.',
    addressPageHeader: 'Company Addresses',
    addressStreet: 'Street name',
    addressTown: 'City',
    addressType: 'Address type',
    addressZip: 'Zip code',
    authConfirmationHeader: 'Verification',
    authConfirmationInfoTextOpen: 'To verify your account an E-Mail has been send to {{email}}.',
    accountPwResetConfirmation: 'An email has been sent. Please confirm it.',
    authConfirmationSuccess: 'Congratulations! \n Your account has been successfully verified',
    checkoutAddress: 'Chose an address',
    checkoutAutoRenewMulti: 'Automatically update licence every {{interval}} Months',
    checkoutAutoRenewSingle: 'Automatically update licence every Month',
    checkoutCredit: 'Credit charge',
    checkoutDebit: 'Debit charge',
    checkoutMail: 'E-Mail request',
    checkoutOrder: 'Order details',
    checkoutOwnedBy: 'Owned by {{owner}}',
    checkoutPayPal: 'PayPal',
    checkoutPayment: 'Chose a payment method',
    checkoutRouteToNewAddress: 'Not the right address here? \n Click to add a new one',
    checkoutRouteToNewBank: 'Not the right bank here? \n Click to add a new one',
    checkoutValueContainer: '{{amount}} €',
    checkoutOrderDetailsHeader: 'Order Details',
    checkoutVisa: 'Visa',
    checkoutToolTip: '{{method}} available soon',
    ComboBoxValueEmpty: '--none--',
    confirmationCancelText: 'Are you sure you want to cancel?',
    confirmationNo: 'No',
    confirmationSureText: 'Are you sure?',
    confirmationYes: 'Yes',
    detailTabDownload: 'Downloads',
    detailTabFeatures: 'Features',
    detailTabNews: 'News',
    detailTabReleases: 'Releases',
    detailTabPricing: 'Pricing',
    detailTabDocuments: 'Documents',
    detailTabNoDocuments: 'No license documents available',
    detailTabDocumentsLicenses: 'Licenses',
    detailTabDocumentsDocuments: 'Documents',
    departmentHeader: 'Departments',
    departmentAlreadyExists: 'Department already exists',
    employeeAccountCreate: 'Create new employee',
    employeeAccountUpdate: 'Edit employee',
    employeeBirthdate: 'Birthday',
    employeeCountry: 'Birthplace',
    employeeDegree: 'Degree',
    employeeDepartment: 'Division',
    employeeEmail: 'E-Mail',
    employeeVerified: "Verified",
    employeeLastPasswordChange: "Last password change",
    employeeGivenName: 'First name',
    employeeLastName: 'Surname',
    employeeName: 'Name',
    employeeNoPhone: 'No Number Supplied',
    employeeNoDepartment: 'No Department Assigned',
    employeeNoBirthplace: 'No Birthplace Supplied',
    employeePageHeader: 'Employee Management',
    employeePhone: 'Phone Number',
    employeeRole: 'Privilege',
    employeeRoles: 'Privileges',
    employeeSalutations: 'Salutation',
    employeeSalutationsFemale: 'Mrs.',
    employeeSalutationsMale: 'Mr.',
    employeeSalutationsOther: 'Divers',
    generalTitle: "Title",
    general_to: "to",
    generalSelectedTab: "Tab",
    generalRoute: "Frontend-Route",
    employeeUsername: 'Username',
    generalDetails: 'Details',
    generalFor: "for",
    generalAll:'All',
    generalReset: "Reset",
    generalRole: "Role",
    generalRoles: "Roles",
    generalAlias: 'Aliases',
    generalManagement: 'Management',
    generalRemove: 'Remove',
    generalArchive: 'Archive',
    generalEdit: 'Edit',
    generalChangesSaved: 'Your changes have been saved successfully',
    generalError: "Error",
    generalSuccess: "Success",
    generalBack: 'Back',
    generalCancel: 'Cancel',
    generalCompanyManagingDirectors: 'Managing Directors',
    generalCompanyName: 'Company',
    generalDescription: 'Description',
    generalFileUploadChoseMulti: 'Choose Files',
    generalFileUploadChoseSingle: 'Choose File',
    generalGroupBy: 'Group by',
    generalName: 'Name',
    generalMutability: 'Mutability',
    generalPermissions: "Permissions",
    generalPermission: "Permission",
    permissionActionBase: "Group",
    permissionActionName: "Action",
    navUsers: "User list",
    generalExpiryDate: "Expires at",
    generalId: "Id",
    generalNext: 'Next',
    generalPassword: 'Password',
    generalSecurity: "Security",
    generalNewPassword: "Neues Password",
    generalRegister: 'Register',
    generalSave: 'Save',
    generalSearch: 'Search',
    generalSortBy: 'Sort by:',
    generalUpload: 'Upload',
    generalProduct: 'Product',
    generalProductId: 'Product-Id',
    generalAvailability: 'Availabilities',
    generalCreate: 'Create',
    generalCreated: 'Created',
    generalImport: 'Import',
    generalVouchers: "Vouchers",
    generalRegexExpressions: "Regular expressions",
    homeNews: 'News',
    homeQuickAccess: "Quick access",
    loginChangePassword: 'Change password',
    loginNewPassword: 'New password',
    loginNoAccount: 'No account?',
    accountProfile: "Profile",
    administration: "Administration",
    adminAvailableBackups: "Available backups",
    adminRestoreHelpText: "This function can be used to restore the application data from a backup. Make sure that the backup is up-to-date and comes from the same instance. Note that all application data is replaced by the data from the backup.",
    adminBackupHelpText: "This function can be used to back up the entire application. Please ensure that the 'BackupPath' path has been configured correctly and that the database user has the necessary rights to perform a backup.",
    adminBackupCreatedText: "Successfully Created Backup: {{fileName}} with a Size of {{size}} MB",
    adminCreateBackup: "Create backup",
    generalBackup: "Backup",
    adminRestore: "Restore from backup (Coming soon)",
    loginOneTimePassword: 'One-time password',
    loginSignIn: 'Login',
    loginInsteadHint: 'Back to login',
    loginSignUp: 'Click here to register',
    loginOutOfDate: 'Your Password seems to be out of Date\nPlease Enter a new one',
    newsAddNews: 'Add new News item',
    newsImage: 'Display Image',
    newsProductRelation: 'Product relations',
    newsAttachments: "Attachments",
    newsTranslations: "Translations",
    managementAboutProd: 'About the software:',
    managementAssignmentError: 'User limit reached on current licence',
    managementAutoRenewal: 'Auto-Renewal:',
    managementBoughtLicences: 'Purchased activations:',
    managementDividerFirstname: 'Firstnames with {{sortedKey}}',
    managementDividerLastname: 'Lastnames with {{sortedKey}}',
    managementDividerLicence: 'User with {{sortedKey}} licence',
    managementDividerNoLicence: 'User without licence',
    managementDividerRole: 'User with {{sortedKey}} Clearance',
    managementDividerUsername: 'Usernames that start with {{sortedKey}}',
    managementEditAssignment: 'assign License',
    managementGroup1None: 'None',
    managementGroup2Licences: 'License',
    managementGroup6Roles: 'User Role',
    managementHeader: 'Assigned Licenses',
    managementLicenceFrom: 'Purchased On:',
    managementLicenceId: 'Licence ID:',
    managementLicenceTo: 'Valid Till:',
    managementMiniFabAdd: 'Assign Licence To User',
    managementMiniFabRemove: 'Removes Licence From User',
    managementNewLicence: 'Buy New Licences',
    managementNextRenewal: 'Next Renewal Date:',
    managementNoLicenceOwned: 'This user has no licences assigned',
    managementNoProductsBooked: 'Looks like you don\'t have a licence to any of our products\nClick here to navigate to the product tab',
    managementOwnedLicenceHeader: 'Licences assigned to the user',
    managementRemainingActivations: 'Remaining Activations:',
    managementProductActive: 'Product activated:',
    managementIsDemo: 'Demo version:',
    managementToOverview: 'Back To Overview',
    managementToProduct: 'To Product',
    managementUserWithLicence: 'User with <b>{{product}}</b> License',
    managementUserWithoutLicence: 'User without <b>{{product}}</b> License',
    licenseOrderConfirmation: "Your license has been successfully ordered!",
    licenseCostPerUserYear: "per user",
    licenseDiscountPerAmount: "From <b>{{amount}}</b> licenses:",
    licenseDiscount: "Discounts",
    licenseDiscountSingular: "Discount",
    licenseDiscountInPercent: "Discount in %",
    licenseSavedHint: "You will save",
    licenseDiscountOldLicenseHint: "Possible additional discounts on already existing licenses (e.g. quantity discounts) are automatically applied after ordering. These are only not taken into account in the current calculation.",
    licenseDiscountHint: "The license discount applies to all purchased licenses as well as features, regardless of the time of order",
    licenseCostPerUserFirstYear: "first year",
    licenseCostPerUserSecondYear: "second year",
    licenseCostPerUserThirdYear: "third year onwards",
    licenseCostMwst: 'Vat.',
    licenseCostInklMwst: 'incl. Vat',
    licenseOrderDemo: 'Order demo version',
    managementProductNoUser: 'No assigned User',
    paymentAccountOwner: 'Account Owner',
    paymentAddNewBank: 'Add new bank account',
    paymentBankName: 'Name of Bank',
    paymentBic: 'BIC',
    paymentIban: 'IBAN',
    paymentPageHeader: 'Payment Details',
    productSateDraft: "Draft",
    productSateAvailable: "Published",
    productSateArchived: "Archived",
    productDescriptions: 'Product descriptions',
    productChoseState: "Select product state",
    productManagementSectionText: "This section contains management functions that have a global effect on the product. These functions should be considered and executed with caution, as the actions may potentially impact the ongoing product business.",
    productLicenceSectionText: "As an administrator, you have the option to upload license agreements for each product. These license agreements are displayed in the download section of each product. They are used to provide the end user with clear information about the product's terms of use and restrictions. By uploading these agreements, you can ensure that your customers are always well informed and use the products according to the established guidelines",
    productDeleteHintText: "If you delete this product, it is no longer visible to customers and can no longer be ordered. Only current contracts of existing customers remain.",
    productArchiveHintText: "Archive this product, it is no longer visible to customers. The last change is kept and if necessary you can restore the product.",
    productPricingAndDiscountSectionText: "In this section you have the possibility to edit prices and discounts for your product. These will take effect immediately. The changes will not take effect for existing customer contracts, but only after the next order or reorder of the customer.",
    productFeatureSectionText: "Here you can describe your product based on features for the customer and customize it in detail in preparation for the following pricing model. Changes to the feature set for existing products do not affect existing products from Kudnen. If changes are made here, they will only be effective for future orders.",
    productScreenshotsSectionText: "Product images are the most important thing for your customers. In this section you can edit, delete or add new ones. Make sure that you use high quality and meaningful images here, so that the customer keeps the focus on the essential product features.",
    productAlreadyBoughtLicences: 'Amount of bought licences',
    productAvailableVersions: 'Available downloads:',
    productBuyLicence: "Buy Licence",
    productChooseEmpty: "No Product",
    productChooseProduct: "Choose a Product",
    productChooseVersion: "Choose a Version",
    productMainHeader: 'Our Products',
    productPaymentInterval: 'Payment Interval',
    productPriceOfLicenceAmount: 'Current Order Price',
    productPricePerLicence: 'Price per licence',
    productProcureAmount: 'Number of Requested licences',
    productRelease: "New Product Version",
    productSearch: 'Search User',
    productAvailableFrom: 'Available From',
    productAvailableTo: 'Available To',
    productFeatureOrderableInDemo: 'Orderable in Demo-Version',
    productFeatureOrderableInProd: 'Orderable in Full-Version',
    productSendRequest: 'Send Request',
    productOrderAcceptTermsAndCondtionsStart: 'I accept the terms of the',
    productOrderAcceptTermsAndCondtionsEnd: 'license agreement',
    newsMainHeader: 'News',
    newsSubHeader: "This Page allows employees and administrators to manage current news. Please note that product information is only relevant when specific news pertains to a particular product and not general information. The publication date is only necessary if an entry is intended to be published in the future.",
    newsDraft: "Draft",
    registerConfirmPassword: 'Password (Confirmation)',
    registerHeader: 'Register',
    releaseDialogPlatform: 'Platform',
    releaseDialogRelease: 'Choose a release',
    releaseDialogVersion: 'Version',
    productReleaseDate: "Released on",
    productReleaseSize: "Size",
    sidebarAccount: 'Account',
    sidebarAccountAddresses: 'Addresses',
    sidebarAccountCompany: 'Company',
    sidebarAccountEmployees: 'Employees',
    sidebarAccountGeneral: 'General',
    sidebarAccountPayment: 'Payment',
    sidebarHome: 'Home',
    sidebarLicenceManagement: 'Licences',
    sidebarProducts: 'Products',
    userAddNewUser: 'Add New User',
    userInfo: 'User Info',
    validationCompareEmail: 'Email addresses do not match',
    validationComparePassword: 'Passwords do not match',
    validationErrorTypeDecimal: 'Not an acceptable decimal input',
    validationErrorTypeUpperCase: 'Has to contain uppercase characters.',
    validationErrorTypeNumbers: 'Has to contain numbers.',
    validationErrorTypeLowerCase: 'Has to contain lowercase characters.',
    validationErrorTypeSpecialChar: 'Has to contain special characters.',
    validationErrorTypeNoUpperCase: 'Shall not contain uppercase characters.',
    validationErrorTypeNoNumbers: 'Shall not contain numbers.',
    validationErrorTypeNoLowerCase: 'Shall not contain lowercase characters.',
    validationErrorTypeNoSpecialChar: 'Shall not contain special characters.',
    validationErrorTypeIban: 'not a valid IBan format',
    validationErrorTypeFailedChecksum: 'Iban has Invalid Checksum',
    validationErrorTypeIbanLength: 'Iban is too short',
    validationErrorTypeNoWhiteSpace: 'Must not contain a space',
    validationInvalidEmail: 'Please enter a valid email address',
    validationIcloudInvalid: 'ICloud email addresses are not supported',
    validationInvalidMaxLength: 'Input shall not have more than {{length}} characters!',
    validationInvalidMinLength: 'Input shall have at least {{length}} characters!',
    validationInvalidPassword: 'Password shall contain at least: one number, one uppercase, one lowercase, one special character and shall at least be 8 characters long',
    validationInvalidPattern: 'Input shall match {{pattern}}',
    validationRequired: '{{label}} is required',
    validationErrorTypePhone: "Please enter a valid phone number",
    validationErrorTypeUrl: "Please enter a valid URL (must start with http:// or https://)",
    validationErrorTypeBic: "Please enter a valid BIC/SWIFT code",
    validationErrorTypePattern: "Invalid format",
    validation_invalidTimeInput:'One of the Time inputs is Invalid',
    passwordRecoverConfirmHeader: 'Set new Password',
    passwordRecoverConfirmNewPassword: 'new Password',
    passwordRecoverConfirmNewPasswordCon: 'confirm Password',
    passwordChangeOld: 'Old password',
    passwordRecoverHeader: 'Reset Password',
    passwordRecoverDescription: 'To reset your password please provide your E-Mail address. After confirming the address you will be sent a link to reset your password',
    generalSend: 'Send',
    passwordForgotten: 'Forgot password?',
    addNewsTitle: 'News Title',
    addNewsNewsText: 'News Contents',
    newsChooseProduct: 'Choose the related product',
    newsChooseType: "Chose News type",
    newsReleaseDate: "News release date",
    newsChooseProductVersion: 'Choose the related product version',
    generalSetDefault: 'Set as Default',
    generalDefault: 'Default',
    productExtendButtonRelease: 'Add Release',
    productExtendButtonNews: 'Add News',
    productExtendButtonProduct: 'Edit Product',
    addressTypeDefault: 'Mailing Address',
    addressTypeShipping: 'Shipping Address',
    addressTypeBilling: 'Billing Address',

    // CRM Translation keys
    dialogHeaderContact: 'Contact Details',
    inPerson: 'Personal',
    letter: 'Letter',
    fax: 'Fax',
    carrierPigeon: 'carrier pigeon',
    addBusinessHours: 'Add business hours',
    addRelationType: 'Choose a relation:',
    addRelationMinComm: 'The message is a {{type}} on:',
    addToDoTitle: 'Create a new ToDo',
    addToDoTask: 'Task',
    addToDoText: 'Description',
    generalWatcher: 'Observer',
    addProjectDialogeOptionalInfos: 'optional information',
    communicationEdit: 'Edit',
    communicationAddRelation: 'Relationships',
    communicationAddStatus: 'For Status',
    communicationDelete: 'Remove',
    addCommunicationTitle: 'New entry',
    commDetailEdit: 'Edit Entry',
    commDetailDelete: 'Remove Entry',
    commDetailTitleInput: 'Title',
    commDetailTextInput: 'Notes',
    commDetailTypeInput: 'Message Type',
    commDetailParent: 'This message is a response to:',
    commDetailRelationHeader: 'Reply to this message',
    companyDisplayChangeCompany: 'Change Company',
    companyDisplayLocalTime: 'Local time',
    companyDisplayBusinessHours: 'Business hours',
    companyDisplayContactPerson: 'Contact person',
    companyDisplayAddNewContact: 'Add contact person',
    companyDisplayLinkNewTracker: 'Start new tracker',
    companyCreateHeader: 'Create new company',
    companyCreateSetTimeZone: 'Time zone shift (h):',
    companyCreateSetName: 'Company name',
    companyCreateSetOpeningTime: 'opening hours',
    companyManagerSignatureMissing: 'Note: The following directors do not yet have a valid signature: ',
    companyManagerSignatureMissingSubText: 'This must be specified for outgoing invoices or other correspondence.',
    companyTaxNumber: "Tax number",
    companySalesTaxNumber: "Sales tax number",
    companyTaxOffice: "Responsible tax office",
    companyCourtOffice: "Name local court",
    companyCourtOfficeNr: "Local court number",
    companyProfitDetermination: "Profit determinations type",
    companyFormOfAccounts: "Form of accounts",
    companyWebsite: "Website",
    companyPhone: "Phone number",
    contactDetailHeader: 'Contact detail',
    contactCreateHeader: 'Create a new contact',
    confirmationTitle: 'Delete entry',
    confirmationText: 'Are you sure you want to delete the entry?',
    confirmationDeleteMultipleText: 'Are you sure you want to delete all selected entries?',
    dialogRelationMulti: 'Select responses',
    dialogRelationSingle: 'Select a parent',
    dialogRelationSetParent: 'set message as parent',
    dialogRelationSetAnswer: 'set message as answer',
    filterByWorkflow: 'filter by workflow',
    filterByStatus: 'filter by status',
    groupAdd: '',
    groupName: '',
    quickInputHead: 'Quick documentation',
    quickInputNewCompany: 'Create new company',
    quickInputOldCompany: 'Extend existing company',
    quickInputTextTitle: 'Title',
    quickInputText: 'Text',
    generalAdd: 'Add',
    generalDate: 'Date',
    generalCompany: 'Company',
    generalCount: "Sum",
    generalPronouns: 'Salutation',
    generalFirstName: 'FirstName',
    generalLastName: 'LastName',
    generalEMail: 'Email',
    generalPhone: 'Phone number',
    generalLogin: 'Login',
    generalContactPerson: 'contact person',
    generalNote: 'note',
    generalChooseWorkflow: 'workflow',
    generalStartingStatus: 'Initial Status',
    generalUser: 'User',
    generalDelete: 'Delete',
    generalUpdate: 'Refresh',
    generalCurrency: '€',
    generalLock: "Lockout",
    generalUnlock: "Unlock",
    generalRolesAndPermissions: "Role & Permissions",
    generalServerSettings: "Server settings",
    generalEnvironment: "Environment",
    generalDiagnostics: "Log & Diagnostics",
    generalIntegrations: "Integrations",
    generalVariablesSettings: "Variables",
    generalBackupRestore: "Backup & Restore",
    generalAccessManagement: "Access Management",
    generalUserAndRoles: "Users & Rights",
    generalComingSoon: "Coming Soon",
    generalPaymentMethods: "Payment methods",
    linkTrackerHeader: 'Start new tracker for {{company}} Start',
    linkTrackerProduct: 'Select a product',
    linkTrackerTracker: 'Select a valid tracker',
    linkTrackerStatus: 'Select an initial status',
    trackerName: 'Tracker Name',
    stepLabelLinktTrackerFirst: 'Tracker type + Tracker name',
    stepLabelLinktTrackerSecond: 'Additional informations',
    openingTimeItemOn: 'On',
    openingTimeItemSelectDay: 'Select a day',
    openingTimeItemFrom: 'From',
    openingTimeItemTo: 'Until',
    projectTableCustomer: 'Customer',
    projectTableOrderNr: 'OrderNo (Customer)',
    projectTableOfferNr: 'OfferNo. (yasc)',
    projectTableProjectName: 'Project name',
    projectTableTeam: 'Employee',
    projectTableStatus: 'Project status',
    projectTableNextBill: 'Next invoice',
    projectTableBillFull: 'Total invoice amount',
    projectTableBillPart: 'Part Amount',
    projectTableBillDue: 'Due on',
    projectTableComments: 'Comment',
    projectTable: 'Percentage of completion',
    projectTableTask: 'Task',
    projectTableToDo: 'Next TODO',
    projectTableNoBill: 'No billing found',
    projectTabletNoToDo: 'No tickets found',
    projectTableAddRole: 'Role',
    projectTableAddInvoiceType: 'Billing type',
    projectTableVolume: 'Project volume',
    projectTableInvoiceCnt: 'Number of invoices',
    projectTablePartialAmount: 'Partial Amount',
    projectTableDueDate: 'Due Date',
    projectTableInvoice: 'Invoices',
    projectTableTooSmallDate: 'The selected date is smaller than that of the last paid entry and could not be set',
    projectTableCustomerNr: 'Customer Nr',
    projectTableRemainingAmount: 'Open Amount',
    projectAddNewProject: 'Add new Project',
    projectBillsTitle: 'Rechnungsdetails',
    projectBillsHelpTextPre: "In this section, you can manage and issue invoices for the selected project.",
    projectBillsHelpTextAfter: "Invoices can be edited until the invoice has been sent. Changes are then only possible via a revision.",
    projectSlideOutTeamHeader: 'Team Details',
    projectTabGeneralTitle: "Project details",
    projectTabGeneralName: "Details",
    projectTabTeamTitle: "Project Team",
    projectTabTeamName: "Team",
    projectTabTodoTitle: "Project todos",
    projectTabTodoName: "Todos",
    projectTabTaskTitle: "Project tasks",
    projectTabTaskName: "Tasks",
    projectTabInvoicesTitle: "Invoices",
    projectTabInvoicesName: "Invoices",
    projectCreatedInvoices: "Created Invoices",
    StartDate:'Start Date',
    EndDate:'End Date',
    StartTime:'Start Time',
    EndTime:'End Time',
    inRange:'Overlaps with other entry',
    endBefore:'End is before Start',
    descriptionOrTask:'Choose a task or add a Description',
    appointmentColor:'Appointment Color',
    timeManagerImportExcel:'Import work-time Excel',
    statusHeaderCurrent: 'Status of the company',
    statusHeaderNoTrackerFound: 'No trackers found',
    toDoNoGroupsFound: 'No ToDo groups found',
    toDoCreateNewGroup: 'Create new group',
    toDoNoTodosFoundInGroup: 'No ToDos found in the group',
    toDoAddNew: 'Create new todo',
    noTrackerFound: 'No trackers found',
    noContractsFound: 'No contracts found',
    navResources: "Resources",
    navInventory: 'Inventory',
    navGlobalVariables: "Variables",
    navDiagnosticLogs: "Server Logs",
    navButtonHumanResources: "Resource planning",
    navButtonProjectBudgets: "Project budgets",
    navButtonTimeManagement: "Time Management",
    navCp: "Customer Portal",
    navCrm: "CRM",
    navFibu: "Bookkeeping",
    navFin: "Finances",
    navButtonDashboard: 'Home',
    navButtonTracker: 'Tracker',
    navButtonDiagram: 'Diagrams',
    navButtonWorkflow: 'Workflow',
    navButtonToDo: 'Tasks',
    navButtonProject: 'projects',
    navButtonCompany: 'Companies',
    navFibUnpostedVouchers: 'Unbooked Vouchers',
    navFibTransactions: 'Transactions',
    navFibBatchBooking: 'Batch Booking',
    navFibUnbookedVouchers: "Unbooked vouchers",
    navFibBankAccounts: 'Bank connections',
    navFibJournal: 'Journal',
    navGlobalPermissions: "Global permissions",
    navGlobalRoles: "Global roles",
    navFibRecurring: 'Recurring',
    navFibTemplates: 'Templates',
    navFibBankSettings: "Banks",
    navFibAccountPlan: "Accounts plan",
    navFibRecurringTitle: 'Recurring Bookings',
    navFibExport: 'Export',
    navFibAccountCreate: "Create Account",
    navEmailClients: "Email-Clients",
    finTransactions: "Bank transactions",
    finBank: "Bank",
    finCashBox: "Cash-Box",
    finSelectBankAccount: "Please select the related bank account",
    none: 'No accounting',
    evenDistro: 'Even distribution',
    custom: 'Self-created',
    asTheyCome: 'Ad Hoc',
    fibuForms: "Active WebForms",
    fibuBookingDate: 'Booking date',
    fibuBookingPrefix: 'Prefix',
    fibuBookingNumber: 'Booking number',
    fibuBookingText: 'Booking text',
    fibuBookingTotal: 'Amount',
    fibuBookingTotalBrutto: "Total brutto",
    fibuBookingTotalNetto: "Total netto",
    fibuBookingAmountType: 'Amount type',
    fibuBookingDebit: 'Debit',
    fibuBookingCredit: 'Credit',
    fibuAddDebit: 'Split Debit',
    fibuAddCredit: 'Split Credit',
    fibuBookingAccount: 'Booking account',
    fibuBookingAccountAddPattern: "Add a regular expression to improve the automated assignment of invoice numbers",
    fibuBookingVatAccount: 'Vat account',
    fibuBookItems: 'Book Items',
    fibuBookItemsDialog: 'Do you want to book all entries into the journal?',
    fibuBookItemsNum: 'Do you really want to book {{amount}} entries into the journal?',
    fibuBookItemsSingle: 'Do you really want to book a single entry into the journal?',
    fibuBookItemsDialogSingle: 'Do you want to book this entry into the journal?',
    fibuOnlyNewBookings: "New bookings only",
    fibuDatevDistributionChannels: "Distribution channels",
    fibuVoucherType: "Voucher type",
    fibuAddVouchers: "Add Voucher(s)",
    fibuBookingType: "Booking type",
    fibuExportOptions: "Export",
    fibuImportDialogMappingTitle: "Assignment of import data",
    fibuImportDialogMappingSubText: "Please provide information about the assignment of your source data. This dialog imports sales data from various systems with the help of already created schemas. These are used to transfer the data in the file to the target system. You can define or change a schema at any time under Accounting / Templates.",
    fibuTemplateName: "Name of template",
    fibuBookingImportTemplates: "Import Templates",
    fibuSelectedUploadTemplate: "Selected upload template",
    fibuBookedBy: "Booked by",
    fibuAmount: "Amount",
    fibuAccountNumber: "Nr",
    fibuAccountName: "Account Name",
    fibuAccountType: "Account Type",
    fibuAccountCategory: "Account Category",
    fibuAccountTaxAccount: "Default Tax Account",
    fibuCredit: "Creditor",
    fibuDebit: "Debitor",
    fibuGlAccount: "GL-Account",
    fibuCreateImportTemplateTitle: "Create import template",
    fibuImportTemplateHelpTextPre: "Upload a CSV file from which you would like to create a template",
    fibuImportTemplateHelpTextAfter: "You can then select the source columns for the required booking information",
    fibuCreateAccountPlan: "Create an account category for your accounting. The customer/vendor or G/L account category is crucial for the calculation and correct allocation of postings for tax purposes",
    fibuCreateBooking: "Create batch booking",
    fibuCreateBookingHelpTextPre: "Create a new posting for the posting batch here. Fill in at least all mandatory fields and, if possible, attach your receipts.",
    fibuCreateBookingHelpTextAfter: "After saving, the booking is immediately available in the batch.",
    fibuCreateTxAlias: "Create creditor alias",
    fibuCreateTxAliasHelpTextPre: "Create a new alias for a creditor here. This will be used for automatic transaction assignment, among other things. Often a creditor such as 'Amazon' has several identities when it comes to bank transactions. For example, names such as 'AMAZON EU S.A R.L.' or 'AMAZON PAYMENTS EUROPE S.C.A.' are used in banking transactions",
    fibuCreateTxAliasTextAfter: "Specify one or more aliases for your creditor below to improve the automatic assignment.",
    fibuCurrentAliasNames: "Current aliases",
    fibuNoAliasNamesPresent: "No aliases present",
    fibuFinancialYear: "Financial year",
    fibuFinancialMonth: "Booking month",
    fibuBalanceSheet: "Balance sheet",
    fibuIncomeSurplusCalculation: "Income-surplus calculation",
    fibuGeneralAccountType: "Account type",
    fibuHasSplits: "Splitted",
    fibuBookingMaskDefault: "Standard booking mask",
    fibuBookingMaskAccount: "Bank account booking mask",
    fibuBookingError: "Remarks",
    fibuConCreate: "Establish bank connection",
    fibuConMakeConnection: "Connect",
    fibuConRemoveConnection: "Disconnect",
    fibuConForwardFinapi: "Continue to login",
    finApiBankId: "FinApi BankId",
    fibuConCreateHelpText: "Enter your access data for your selected connection. Your entries will be transmitted to the bank in encrypted form.",
    fibuConCreateHelpText2: "The connection data is used exclusively to display sales and allocate bookings.",
    fibuTransactionsBooked: "Booked",
    fibuTransactionsAccountNumber: "Account Number",
    fibuTransactionsBankBookingDate: "Booking date",
    fibuTransactionsCounterpart: "Counterpart",
    fibuTransactionsPurpose: "Purpose",
    fibuTransactionsTotal: "Sum",
    fibuFinApiStatusPENDING: "Created",
    fibuFinApiStatusINPROGRESS: "In Progress",
    fibuFinApiStatusREADY: "Connected",
    fibuLocalBookingAccount: "Local booking account",
    fibuExportLexwareXml: "Lexware XML Export",
    fibuExportLexwareCsv: "Lexware CSV Export",
    fibuExportTotal: "Bookings total",
    fibuExportNewBookings: "New Bookings",
    fibuExportSelected: "Bookings selected",
    fibuExportNotSelected: "Bookings not selected",
    fibuRecurrence: "Day of execution",
    fibuBookedRecurring: "{{booking}} successfully transferred to batch bookings",
    fibuSplitCredit: "Credit",
    fibuSplitDebit: "Debit",
    fibuBookingSource: "Source",
    fibuImportReceipts: "Import Receipts",
    bookingSourceManual: "Manual",
    bookingSourceRecurring: "Template",
    bookingSourceFinApi: "FinApi",
    bookingSourceEmail: "Email",
    bookingSourceLexware: "Lexware",
    bookingSourceOcrImport: "OcrImport",
    finApiCreated: "Created",
    finApiPending: "Pending",
    finApiConnected: "Connected",
    finApiFailure: "Failure",
    finApiPaused: "Paused",
    generalExecutionDay: "Day of execution",
    generalInterval: "Interval",
    generalFormat: "Format",
    generalExport: "Export",
    generalDateFrom: "Date from",
    generalDateUntil: "Date until",
    generalCreatedBy: "Created by",
    generalStatus: "State",
    generalRegexPattern: "Regular expression",
    generalRegexCaptureGroup: "Regex capture group",
    generalAccountInfos: "Account information",
    generalGroupName: "Group",
    generalGroupAdd: "Add Group",
    generalBuyer: "Buyer",
    generalPieces: "Pieces",
    generalHours: "Hours",
    generalOrderIdShort: "Order no.",
    generalOrderId: "Order no.",
    generalReceiptNoShort: "Receipt no.",
    generalReceiptNo: "Receipt number",
    generalPosition: "Position",
    generalPositions: "Positions",
    generalReceiver: "Receiver",
    generalSent: "Sent",
    generalType: "Type",
    generalReadAll: "Read all",
    generalClearAll: "Clear all",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    semiAnnual: "Semi-Annual",
    annual: "Annual",
    datevFormatJournalBased: "DATEV journal based",
    datevBookingBased: "DATEV booking based",
    datevStammdaten: "DATEV master data based",
    standardNetto: "Gross",
    standardBrutto: "Net",
    verkaufsrechnung: "Sales invoice",
    einkaufsrechnung: "Purchase invoice",
    verkaufsGutschrift: "Sales credit note",
    einkaufsGutschrift: "Purchase credit",
    verkaufsSchlussrechnung: "Final sales invoice",
    einkaufsSchlussrechnung: "Final purchase invoice",
    gutschriftsanzeige: "Credit advice",
    ausgangsrechnung: "Outgoing invoice",
    ausgehendeGutschrift: "Outgoing credit note",
    gutschriftanzeige: "Credit note",
    eingangsrechnung: "Incoming invoice",
    eingehendeGutschrift: "Incoming credit note",
    eingehendeZahlung: "Incoming payment",
    ausgehendeZahlung: "Outgoing payment",
    sachbuchung: "G/L posting",
    vortragsbuchung: "Lecture booking",
    eingehendeManuelleErfassung: "Incoming Manual Recording",
    ausgehendeManuelleErfassung: "Outgoing Manual Recording",
    skr03: "Skr-03",
    skr04: "Skr-04",

    emailIntegrationFormularCreate: "Create Email-Client",
    emailIntegrationFormularUpdate: "Update Email-Client",
    emailIntegrationFormularHelpTextPre: "Create a new global email client here. Fill in at least all mandatory fields.",
    emailIntegrationFormularHelpTextAfter: "This can be used for numerous features within the application.",
    emailIntegrationClientType: "Client Typ",
    emailIntegrationHost: "Host",
    emailIntegrationPort: "Port",
    emailIntegrationUserName: "Username",
    emailIntegrationPassword: "Password",
    emailIntegrationUseSsl: "UseSsl",
    emailIntegrationDescription: "Description",
    emailIntegrationLastUsed: "Last Used",
    emailConnectionStatus: "Connection Status",
    emailIntegrationTestReceiver: "Test mail receiver",
    emailTestConnection: "Test connection",
    connectionSuccessText: "Connection success",
    connectionFailedText: "Connection failed",


    ///CRM WORKFLOW
    workflowUsedIn: 'Used in {{count}} {{type}}',
    workflowAdd: 'Add new Workflow',
    workflowUpdate: 'Save Changes',
    workflowDiscard: 'Discard Changes',
    workflowAddStatus: 'Add Status',
    workflowAddTransition: 'Add Link',
    toDo: 'To-Do',
    product: 'Product',
    project: 'Project',
    noProject: 'No Projects Found',
    recruitment: 'Recruitment',
    name: 'Name',
    color: 'Farbe',
    description: 'Description',
    label: 'Link Label',
    from: 'From',
    to: 'To',
    save: 'Save',
    cancel: 'Cancel',
    workflowLinksToStates: 'Links to other Status',
    fromStatus: 'from Status',
    toStatus: 'to Status',
    transition: 'Transition',

    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly',
    recExpandAll: 'Expand All',
    recCollapseAll: 'Collapse All',
    recDateRangeSetting: 'Date Range',

    plannedHour: 'Planned Hours',
    estimatedHour: 'Estimated Hours',
    usedTime: 'Used up Time',
    user: 'User',

    addInvoice: 'Add Invoice',
    sendInvoice: "Send Invoice",
    paymentTarget: 'Payment planned on',
    paidOn: 'Paid on',
    paid: 'Paid',
    date: 'Date',
    amount: 'Amount',
    price: 'Cost',
    add: 'Add',
    remaining: 'Remaining',

    recDateOffset: '',
    recOpenDialog: 'Open Recurrence Dialoge',
    directiveStart: '',
    task: 'Task',
    recStart: 'Start',
    recDuration: 'Duration',
    recFrequency: 'Frequency',
    recInterval: 'Interval',
    recEnd: 'End',
    recEndOption: 'End Option',
    recCount: 'Count',
    recProjectView: 'Project view',
    recUserView: 'User view',
    addNewProject: 'Add new Project',
    addWorkflow: 'Add Workflow',
    workflowEditorShowEdgeLabel: 'Toggle Edge Labels',
    workflowEditorStatusSettings: 'Status Settings',
    workflowEditorEdgeSettings: 'Transition Settings',
    center: 'Center View',
    humanResourcesInvalidTimeInput: 'Invalid Input',

    //TimeManager
    timeManagerTaskListFav: 'Marked',
    timeManagerTaskListProj: 'Projects',
    timeManagerTaskListRecent: 'Recent',
    timeManagerTaskListAssigned: 'Assignment',
    timeManagerTaskListAll: 'All',
    timeManagerFavourite: 'Marked Tasks',
    timeManagerNotFavourite: 'Unmarked Tasks',
    timeManagerLow: '',
    timeManagerModerate: '',
    timeManagerHigh: '',
    timeManagerNone: '',
    timeManagerAssignedToMe: 'Assigned to Me',
    timeManagerNotAssignedToMe: 'Not Assigned to Me',
    timeManagerAll: 'All',
    timeManagerDisplayedCw: 'Displayed Calender Week:',
    timeManagerResetDate: 'Reset Date',
    timeManagerDndTable: 'Weekly Table',
    timeManagerWeeklyTables: '',
    timeManagerWorkTime: '',

    calendar_noEntries: "No entries for this day",
    calendar_event_type: "Event type",

    calendarTypeWorkTime: "Work time",
    calendarTypeVacation: "Vacation",
    calendarTypeTimeOff: "Time off in lieu",
    calendarTypeSick: "Sick",
    calendarTypeAppointment: "Appointment",
    calendarTypeUnknown: "Entry",

    calendar_allDay: "All day",
    calendar_dayPart: "Day part",
    calendar_carryOver: "Carry over",

    calendar_dayPartNone: "None",
    calendar_dayPartMorning: "Morning",
    calendar_dayPartAfternoon: "Afternoon",
    calendar_dayPartFullDay: "Full day",

    calendar_recurrence: "Recurrence",
    calendar_recurrencePreset: "Recurrence preset",

    calendar_recurrenceNone: "No recurrence",
    calendar_recurrenceDaily: "Daily",
    calendar_recurrenceWeekly: "Weekly",
    calendar_recurrenceWeekdays: "Weekdays Mon to Fri",
    calendar_recurrenceMonthly: "Monthly",

    calendar_recurrenceHintExample: "Example FREQ=WEEKLY;BYDAY=MO,WE,FR",
    calendar_currentWeek: "Calendar week",
    validation_rRuleMissing: "RRULE is missing",
    validation_invalidRRule: "Invalid recurrence rule",
    validation_invalidTimeZoneId: "Invalid time zone",

    calendar_help_allDay: "Automatically sets the time to a full day. Reporting treats this as a day based entry.",
    calendar_help_dayPart: "Defines whether this is counted as half day or full day. Mainly used for absences.",
    calendar_help_carryOver: "Flag for reporting and quotas. Used for vacation and time off in lieu.",
    calendar_help_recurrence: "Creates recurring entries. Available for work time and appointments.",

    calendar_summary_title: "Summary",
    calendar_summary_range: "Range",
    calendar_summary_duration: "Time span",
    calendar_summary_counting: "Counting",
    calendar_summary_recurrence: "Recurrence",
    calendar_summary_carryOverFlag: "Carry over enabled",

    calendar_summary_counting_timeSpan: "Counted based on the time span.",
    calendar_summary_counting_allDay: "Counted as all day.",
    calendar_summary_counting_dayPart: "Counted based on the day part.",

    calendar_section_required: "Required fields",
    calendar_section_optional: "Optional fields",
    calendar_section_advanced: "Advanced",
    calendarEntryLabelShort_workTime: "WT",
    calendarEntryLabelShort_vacation: "V",
    calendarEntryLabelShort_timeOff: "TO",
    calendarEntryLabelShort_publicHoliday: "PH",
    calendarEntryLabelShort_sick: "S",
    calendarEntryLabelShort_appointment: "A",
    calendarEntryLabelShort_unknown: "E",
    calendarEntryLabel_workTime: "Work time",
    calendarEntryLabel_vacation: "Vacation",
    calendarEntryLabel_timeOff: "Time off",
    calendarEntryLabel_sick: "Sick leave",
    calendarEntryLabel_appointment: "Appointment",
    calendarEntryLabel_unknown: "Entry",

    validation_requiredTitle: "Title is required",
    validation_requiredProject: "Project is required",
    validation_requiredDescription: "Description is required",

    resetPermissionTooltip: "Resets all permissions to default values",
    notifyResetDone: "Standard permissions have been restored",
    roleProjectManager: "PJM",
    roleProjectManagerTip: "Project Manager",
    roleUser: "User",
    roleUserTip: "Standard User",
    roleHr: "HR",
    roleHrTip: "Human Resource Manager",
    roleBookkeeper: "Bk",
    roleBookkeeperTip: "Bookkeeper",
    roleFinancier: "FZ",
    roleFinancierTip: "Financier",
    roleOrderAndLicensing: "OL",
    roleOrderAndLicensingTip: "Ordering & Licensing",
    roleInventoryManager: "Inv",
    roleInventoryManagerTip: "Inventory Manager",
    roleProductManager: "PDM",
    roleProductManagerTip: "Product Manager",
    userDetailsView: "User: {{username}}",
    userDetailsInfo: "Here you can view and edit all user information. It is also possible to assign rights. Be aware of the possible consequences of changes for the respective user.",
    userDetailsInfoTextAfter: "After saving, the user is immediately updated in Overview.",
    userSecurityInfo: "Here you can view and execute all security-relevant functions. Be aware of the possible consequences of changes for the respective user.",
    userSecurityInfoTextAfter: "After saving, the user is immediately updated in Overview.",
    userSecurityResetPw: "Reset password",
    userSecurityLastLogin: "Last Login",
    userSecurityLastPasswordChange: "Last password change",
    userSecurityLockoutEnd: "Locked until",
    userSecurityRegisteredSince: "Registered since",
    userSecurityIsActive: "Is Aktive",
    general: "General",
    generalActive: "Active",
    userSecurityPwSetSuccess: "Password successfully set.",
    userSecurityLockUser: "Lockout user",
    userSecurityLockAndUnlock: "Lock & Unlock",
    userSecurityUnlockUser: "Unlock user",
    userSecurityLockoutUserSuccess: "User successfully locked out",
    userSecurityUnlockUserSuccess: "User successfully unlocked",
    userRolesInfo: "You can view and change all rights here. Be aware of the possible consequences of changes for the respective user.",
    userRolesInfoTextAfter: "After saving, the user is immediately updated in Overview.",
    userUpdatedSuccess: "User successfully updated",
    paymentEditTitle: "Edit Bankconnection",
    paymentEditHelpTextPre: "You can view and change your bank details here. Not all information is shown for security reasons. You can still update your bank details.",
    paymentEditHelpTextAfter: "After saving, the bank details are immediately updated in the overview.",
    projectHelpTextPre: "You can view and change your project details here.",
    projectHelpTextAfter: "After saving, the bank details are immediately updated in the overview.",
    projectTeamHelpTextPre: "Here you can view and change your project team. Be aware that users may be granted access to sensitive data if they are misassigned.",
    projectTeamHelpTextAfter: "After saving, the team is immediately updated in the overview.",
    sendInvoiceHelpTextPre: "Here you can send the selected invoice <strong>{{InvoiceNum}}</strong> and add optional recipients in addition to the contact <strong>{{ContactMail}}</strong>.",
    sendInvoiceHelpTextAfter: "Also make sure that the recipients entered are also authorized to view invoice information",
    sendInvoiceSuccess: "The invoice '{{InvoiceNum}}' was sent successfully.",
    helpTextBugTitle: "Enter a descriptive title for the bug",
    helpTextFrontendRoute: "On which page did the error occur, e.g., (/cp/home)",
    helpTextTicketType: "What exactly is noted?",
    helpTextDescription: "Describe the specific error and its impact if possible",
    helpTextStepToReproduce: "Step to reproduce (e.g. Click A, See B)",
    stepsToReproduce: "Steps to reproduce",
    stepToReproduceNr: "Step {{stepNo}}",
    bugTicketCreationSucceeded: "Your ticket has been successfully created",
    bugTicketCreationFailed: "Error while creating your bug ticket. Please try again later",
    userChangeRoleHint: "Users cannot change their roles themselves. Contact someone with a higher role",
    ticketTypeBug: "Bug",
    ticketTypeImprovement: "Improvement",
    ticketTypeFeatureRequest: "Feature-Request",
    changeNewsPreviewImage: "Upload Image",
    variableContext: "Context",
    variableValue: "Value",
    variableNameLabel: "Variable Name",
    variableNameToolTip: "Name of the variable",
    variableNamePlaceholder: "Name of the variable",
    variableContextLabel: "Variable Context",
    variableContextToolTip: "Context (group) of the variable",
    variableContextPlaceholder: "Context (group) of the variable",
    variableValueLabel: "Variable Value",
    variableValueToolTip: "Value of the variable",
    variableValuePlaceholder: "Value of the variable",
    variableHelpTextPre: "In the following form, you can update the value of a single variable.",
    variableHelpTextAfter: "Variables are predefined by the system and can only be viewed and updated. Creating a variable is only done by the developers.",

    ///After this point adhere to the described standard!!!!!
    /// Translation keys shall conform to the specified format:
    /// {{module Name}}_{{component Name}}_{{meaning}}_{{usage}}
    /// module Name: name of the module in which the key will be used
    /// component Name: name of the component in which the key will be used
    /// meaning: what the key is intended to represent(e.g. login)
    /// usage: what the key will be used as (e.g. label, header, button)
    /// example: auth_login_resetPassword_link
    /// Exception:
    /// general use translation keys (e.g. save, cancel, continue, password,.....) shall fall under the module general and
    /// do not require a component
    /// example: general_save_button

    general_title:'Title',
    general_name:'Name',
    general_user: 'User',
    general_employee:'Employee',
    general_firstName:'First Name',
    general_lastName:'Last Name',
    general_email:'E-Mail',
    general_phone:'Phone',
    general_mobile:'Mobile',
    general_address:'Address',
    general_country:'Country',
    general_federalState:'Federal State',
    general_city:'City',
    general_zipCodeShort:'ZipCode',
    general_zipCode:'Zip-Code',
    general_streetName:'Street Name',
    general_streetNumber:'Street Number',
    general_company:'Company',
    general_salutation:'Salutation',
    general_description:'Description',
    general_website:'Website',
    general_department:'Department',
    general_save:'Save',
    general_delete: 'Delete',
    general_edit: 'Edit',
    general_chooseState:'Select a state',
    general_create:'Create',
    general_empty:'-- empty --',
    general_role:'Role',
    general_currentStatus:'Current Status',
    general_contact:'Contacts',
    general_project:'Project',
    general_excelImport:'Import Excel',
    general_index:'Index',
    general_startDate:'Start date',
    general_startTime:'Start time',
    general_endDate:'End date',
    general_endTime:'End time',
    general_hrsShort: "hrs",
    general_clockSuffix: "",
    general_duration: "Duration",
    general_none:'',
    general_pending:'Pending',
    general_accepted:'Accepted',
    general_rejected:'Rejected',
    general_canceled:'Canceled',
    general_vacation:'Holiday',
    general_sick:'Sick',
    general_timeOff:'Time off',
    general_publicHolidays: 'Public holidays',
    general_publicHoliday: 'Public holiday',
    general_days: "Days",
    general_day: "Day",
    general_currentWorkflow: "Current Workflow",
    general_backendId:'Backend Id',
    general_customerNumber: 'Customer number',
    general_phone_hint: 'International format: +49 123 456789',

    ///Controller
    //General
    controller_general_delete_success:'{{number}} {{entity}} successfully deleted.',

    //Task
    controller_task_deleteSingleText_Label:'are you sure you want to delete one Task?',
    controller_task_deleteMultiText_Label:'are you sure you want to delete {{number}} Tasks?',

    ///App
    //Navigation
    app_navigation_timeManagement_label:'Time Tracking',
    app_navigation_task_label:'Tasks',
    app_navigation_vacationManagement_label:'Vacation management',
    app_navigation_vacationApproval_label:'Vacation Application',

    ///crm
    //Company
    crm_company_basicInfo_tabLabel:'Basic Info',
    crm_company_addressInfo_tabLabel:'Addresses',
    crm_company_bankAccounts_tabLabel:'Bank Accounts',
    crm_company_resource_tabLabel:'Resources',
    crm_company_toResources_button:'Navigate to Contacts page',

    //Task
    crm_task_taskName_label:'Task',
    crm_contract_customerFacingId_label:'set ID',
    crm_contract_taskRisks_label:'Risks',
    crm_contract_taskClarifications_label:'Clarifications',
    crm_contract_taskBudget_label:'Budget',
    crm_contract_taskCurrentEstimated_label:'Est.',
    crm_contract_connectedContacts_label:'Contacts',
    crm_contract_taskCurrentStart_label:'Start',
    crm_contract_taskCurrentEnd_label:'End',
    crm_contract_taskEstimatedEffortSum_label:'Est. Task Duration',
    crm_contract_taskActualEffortSum_label:'Task Duration',
    crm_contract_category_label:'Category',
    crm_task_currentStart_label:'Current Start',
    crm_task_currentEnd_label:'Current End',
    crm_task_currentEst_label:'Current Estimated',
    crm_task_currentPlanned_label:'Current Planned',
    crm_task_effortTypes_label:'Effort Types',
    crm_task_duration_label:'Est Duration',
    crm_task_actualDuration_label:'Actual Duration',
    crm_task_entityName:'Tasks',
    crm_task_details_sectionTitle:'Task Details',
    crm_task_id_label:'ID',
    crm_task_taskId_label:'Task ID',
    crm_task_taskType_label:'Task Type',
    crm_task_mockup_label:'Mockups',
    crm_task_contact_label:'Contact',
    crm_task_references_label:'References',
    crm_task_originalStart_label:'Original Start',
    crm_task_originalEnd_label:'Original End',
    crm_task_originalEstimated_label:'Original Estimate',
    crm_task_recentAppointments_label:'Recent Appointments',
    crm_contract_referencedTasks_label:'Referenced Tasks',
    crm_contract_referencedByTasks_label:'Referenced By',
    crm_contract_taskEffort_label:'Efforts',

    //TaskEffort
    crm_taskEffort_effortName_label:'Effort',

    //Address Info
    crm_addressInfo_table_header:'Saved Addresses',
    crm_addressInfo_multiDelete_text:'are you sure you want to delete {{number}} Addresses?',

    //Projects
    crm_projects_addTeamMember_header:'Add Team Member',
    crm_projects_nextBill_tableHeader:'Next Bill',

    //Contacts
    crm_contacts_multiDelete_text:'are you sure you want to delete {{number}} contacts?',
    crm_basicContactInfo_header_header:'Contact Information',
    crm_basicContactInfo_description_label:'Here you can view the information of a chosen contact edit it or create a new one.',

    //Company
    crm_company_multiDelete_text:'are you sure you want to delete {{number}} Companies?',

    ///Resource Manager
    //Human Resources
    resourceManager_humanResources_noTaskOnProject_label:'No task assigned to this Project',
    resourceManager_humanResources_addTask_label:'Create new Task for this Project',

    partialViews_dialog_calendarExport_header: "Export timesheets",
    resourceManager_calendarExport_users_label:'Select users',
    resourceManager_calendarExport_summary_title:'Export summary',
    resourceManager_calendarExport_currentUserFallback_label:'Current user',
    resourceManager_calendarExport_usersSelected_label:'users selected',
    resourceManager_calendarExport_invalidRange_label:'The end date must be after the start date.',
    resourceManager_calendarExport_missingCustomerAddress_label:'No address configured for the customer.',
    resourceManager_calendarExport_project_label:'Project',

    //TimeTracker
    resourceManager_timeTracker_onPageLeave_label:'Unsaved Entries',
    resourceManager_timeTracker_dismiss_label:'Dismiss entries',
    resourceManager_timeTracker_saveUnused_label:'Save unsaved entries',
    resourceManager_timeTracker_returnToCurrentWeek_button:'Return to Current Week',
    resourceManager_timeTracker_currentWeek_label:'Calender Week',
    resourceManager_timeTracker_currentViewed_label:'Currently Viewing',
    resourceManager_timeTracker_taskListAll_label:'All',
    resourceManager_timeTracker_openOvertime_label:'Overtime',

    //CalendarStatistics
    resourceManager_calendarStatistic_yearStats_tabHeader: 'Yearly statistics',
    resourceManager_calendarStatistic_weekStats_tabHeader: 'Weekly statistics',

    resourceManager_calendarStatistic_weeklyTargetHours_label: 'Weekly hours',

    resourceManager_calendarStatistic_vacationDaysEntitled_label: 'Vacation days per year',
    resourceManager_calendarStatistic_vacationDaysTaken_label: 'Vacation days taken so far',
    resourceManager_calendarStatistic_vacationDaysPlanned_label: 'Planned vacation days',
    resourceManager_calendarStatistic_vacationDaysAvailableNow_label: 'Vacation currently available',
    resourceManager_calendarStatistic_vacationCarryOver_label: 'Vacation carryover currently available',
    resourceManager_calendarStatistic_vacationCarryOverDeadlineNext_label: 'Next vacation carryover expiry date',

    resourceManager_calendarStatistic_sickDaysTaken_label: 'Sick days so far',

    resourceManager_calendarStatistic_overtimeAvailableNow_label: 'Current overtime balance',
    resourceManager_calendarStatistic_overtimeRawCurrentYear_label: 'Overtime this year',
    resourceManager_calendarStatistic_overtimeCarryOver_label: 'Overtime carryover currently available',
    resourceManager_calendarStatistic_overtimeCarryOverDeadlineNext_label: 'Next overtime carryover expiry date',

    resourceManager_calendarStatistic_expectedHours_label: 'Target hours',
    resourceManager_calendarStatistic_adjustedExpectedHours_label:'Target hours with overtime balance',
    resourceManager_calendarStatistic_overtimeBalanceBeforeWeek_label:'Overtime balance before week start',
    resourceManager_calendarStatistic_workedHours_label: 'Worked hours',
    resourceManager_calendarStatistic_sickDays_label: 'Sick days',
    resourceManager_calendarStatistic_absenceCreditHours_label: 'Absence credit hours',
    resourceManager_calendarStatistic_overtimeHours_label: 'Overtime',
    resourceManager_calendarStatistic_remainingHours_label: 'Remaining hours',

    resourceManager_projectStatistics_budget_tabTitle: "Budget",
    resourceManager_projectStatistics_budget_tabName: "Budget",
    resourceManager_projectStatistics_years_tabTitle: "Years",
    resourceManager_projectStatistics_years_tabName: "Years",
    resourceManager_projectStatistics_users_tabTitle: "Employees",
    resourceManager_projectStatistics_users_tabName: "Employees",
    resourceManager_projectStatistics_filter_label: "Display",
    resourceManager_projectStatistics_refresh_button: "Refresh",
    resourceManager_projectStatistics_projects_statLabel: "Projects",
    resourceManager_projectStatistics_totalBudget_statLabel: "Total budget",
    resourceManager_projectStatistics_openBudget_statLabel: "Open budget",
    resourceManager_projectStatistics_plannedHours_statLabel: "Planned hours",
    resourceManager_projectStatistics_actualHours_statLabel: "Actual hours",
    resourceManager_projectStatistics_deltaHours_statLabel: "Delta",
    resourceManager_projectStatistics_filter_all_option: "All projects",
    resourceManager_projectStatistics_filter_open_option: "Open budget only",
    resourceManager_projectStatistics_filter_worked_option: "With actual hours only",
    resourceManager_projectStatistics_totalBudget_label: "Total budget",
    resourceManager_projectStatistics_openBudget_label: "Open budget",
    resourceManager_projectStatistics_usedBudget_label: "Used",
    resourceManager_projectStatistics_plannedHours_label: "Planned hours",
    resourceManager_projectStatistics_actualHours_label: "Actual hours",
    resourceManager_projectStatistics_deltaHours_label: "Delta",
    resourceManager_projectStatistics_budgetUsage_label: "Budget usage",
    resourceManager_projectStatistics_userName_header: "Name",
    resourceManager_projectStatistics_userPlannedHours_header: "Planned hours",
    resourceManager_projectStatistics_userActualHours_header: "Actual hours",
    resourceManager_projectStatistics_year_header: "Year",
    resourceManager_projectStatistics_appointments_header: "Appointments",
    resourceManager_projectStatistics_worklogs_header: "Worklogs",
    resourceManager_projectStatistics_yearPlannedHours_header: "Planned",
    resourceManager_projectStatistics_yearActualHours_header: "Actual",
    resourceManager_projectStatistics_yearDeltaHours_header: "Delta",
    resourceManager_projectStatistics_customer_columnLabel: "Customer",
    resourceManager_projectStatistics_project_columnLabel: "Project",
    resourceManager_projectStatistics_totalBudget_columnLabel: "Total budget",
    resourceManager_projectStatistics_openBudget_columnLabel: "Open budget",
    resourceManager_projectStatistics_plannedHours_columnLabel: "Planned hours",
    resourceManager_projectStatistics_actualHours_columnLabel: "Actual hours",
    resourceManager_projectStatistics_deltaHours_columnLabel: "Delta",
    resourceManager_projectStatistics_teamMembers_columnLabel: "Team members",
    resourceManager_projectStatistics_tasks_columnLabel: "Tasks",
    resourceManager_projectStatistics_coverageFrom_columnLabel: "Coverage from",
    resourceManager_projectStatistics_coverageTo_columnLabel: "Coverage to",
    resourceManager_projectStatistics_table_label: "Project statistics",
    resourceManager_projectStatistics_noYears_label: "No yearly statistics available",
    resourceManager_projectStatistics_noUsers_label: "No employee statistics available",
    resourceManager_projectStatistics_period_label: "Period",
    resourceManager_projectStatistics_period_all_option: "All years",
    resourceManager_projectStatistics_period_year_option: "Single year",

    //bannerItem
    resourceManager_bannerItem_halfDay_label: '1/2 {{type}} day',

    //VacationManagement
    resourceManager_vacationManager_vacationStats_header:'Vacations in given year',
    resourceManager_vacationManager_addNewEntry_label:'Add new Vacation',

    //AbsenceManager
    resourceManager_absenceManager_personalView_lable:'Single view',
    resourceManager_absenceManager_generalView_lable:'Company view',

    //VacationApproved
    resourceManager_vacationApproved_application_header:'Vacation Application',
    resourceManager_vacationApproved_pending_label:'Pending',
    resourceManager_vacationApproved_history_label:'History',
    resourceManager_vacationApproved_viewSelect_label:'Select View',
    resourceManager_vacationApproved_rejectAll_button:'Reject all selected Applications',
    resourceManager_vacationApproved_approveAll_button:'Approve all selected Applications',
    resourceManager_vacationApproved_durationInDay_label:'Urlaubsdauer in Tagen',
    resourceManager_vacationApproved_decisionStatus_label:'Entscheidungsstatus',
    resourceManager_vacationApproved_multiDelete_text:'are you sure you want to decline {{number}} vacation applications?',
    resourceManager_vacationApproved_delete_text: "Are you sure you want to delete the request?",

    ///Partial Views
    //Dialog
    //Confirmation
    partialViews_dialog_confirmationDefaultText_label:'Are you sure?',
    partialViews_dialog_confirmationDefaultNo_button:'No',
    partialViews_dialog_confirmationDefaultYes_button:'Yes',

    //TimeManagerEntry
    partialViews_dialog_addTimeEntry_header:'Log working time',

    ///Formulars
    //Project Team Formular
    formular_projectTeam_helpText_text:'Here you can view and edit your project team. Be aware that incorrectly assigned users may be granted access to sensitive data.\nAfter saving, the project will be immediately updated in the overview.',

    //Bank Account Formular
    formular_bankAccount_table_title:'Saved Bank Accounts',
    formular_bankAccount_accountOwner_label:'Account Owner',
    formular_bankAccount_bankName_label:'Bank Name',
    formular_bankAccount_iban_label:'IBan',
    formular_bankAccount_bic_label:'BIC',
    formular_bankAccount_billingAccountOnly_label:'Billing Account only',
    formular_bankAccount_default_label:'Default Account',
    formular_bankAccount_multiDelete_text:'are you sure you want to delete {{number}} Bank accounts?',
    formular_bankAccount_iban_hint: 'e.g. DE89 3704 0044 0532 0130 00',
    formular_bankAccount_bic_hint: 'e.g. COBADEFFXXX',


    general_save_button: 'Save',
    general_cancel_button: 'Cancel',
    general_comingSoon_label: 'Coming soon',

    account_account_eyebrow_label: 'Account',
    account_account_title_header: 'My account',
    account_account_description_text: 'Personal settings, security, integrations, and individual workspace options.',

    account_account_profileStat_label: 'Profile',
    account_account_profileStat_complete_value: 'Complete',
    account_account_profileStat_incomplete_value: 'Incomplete',
    account_account_profileStat_complete_hint: 'Your profile is fully completed.',
    account_account_profileStat_incomplete_hint: 'Your profile is not fully completed yet.',
    account_account_profileStat_hint: 'Master data maintained',

    account_account_integrationsStat_label: 'Integrations',
    account_account_integrationsStat_value: '{{count}} active',
    account_account_integrationsStat_hint: 'Active connections',

    account_account_securityStat_label: 'Security',
    account_account_securityStat_value: '{{count}} notice',
    account_account_securityStat_hint: 'Recommended reviews',

    account_account_accountSection_header: 'Account',
    account_account_accountSection_text: 'Personal data and basic account information',

    account_account_personalData_header: 'Personal data',
    account_account_personalData_text: 'Edit name, contact details, and master data',
    account_account_personalData_status_badge: 'Current',
    account_accountPersonalData_recommendations_header: 'Profile notes',
    account_accountPersonalData_recommendations_text: '{{count}} items should be completed.',

    account_accountSecurity_recommendations_header: 'Security notes',
    account_accountSecurity_recommendations_text: '{{count}} recommendations are open.',

    account_account_companyRole_header: 'Company and role',
    account_account_companyRole_text: 'View assigned company and role overview',

    account_account_securitySection_header: 'Security',
    account_account_securitySection_text: 'Access, authentication, and personal tokens',

    account_account_passwordLogin_header: 'Password and sign in',
    account_account_passwordLogin_text: 'Change password and review active sessions',
    account_account_passwordLogin_status_badge: 'Recommendation',

    account_account_apiTokens_header: 'API tokens',
    account_account_apiTokens_text: 'Manage personal API access',
    account_account_apiTokens_status_badge: 'Disabled',

    account_account_integrationsSection_header: 'Integrations',
    account_account_integrationsSection_text: 'Personal connections to external services',

    account_account_calendar_header: 'Calendar',
    account_account_calendar_text: 'Connect Google, Outlook, or ICS',
    account_account_calendar_status_badge: 'Connected',
    account_account_calendar_meta: '{{count}} active',

    account_account_mail_header: 'Email',
    account_account_mail_text: 'Manage personal mail integrations',

    account_accountPersonalData_eyebrow_label: 'Account',
    account_accountPersonalData_title_header: 'Personal data',
    account_accountPersonalData_description_text: 'Maintain your personal master data and contact details.',
    account_accountPersonalData_back_button: 'Back to My account',
    account_accountPersonalData_masterData_header: 'Master data',
    account_accountPersonalData_masterData_text: 'Name, contact details, and additional personal information',

    // account security
    account_accountSecurity_eyebrow_label: 'Account',
    account_accountSecurity_title_header: 'Password and security',
    account_accountSecurity_description_text: 'Manage your password and review security-related settings for your account.',
    account_accountSecurity_back_button: 'Back to My account',

    account_accountSecurity_changePassword_button: 'Change password',

    account_accountSecurity_passwordPanel_header: 'Change password',
    account_accountSecurity_passwordPanel_text: 'Change the current password for this account.',

    account_accountSecurity_email_label: 'Email',
    account_accountSecurity_currentPassword_label: 'Current password',
    account_accountSecurity_newPassword_label: 'New password',
    account_accountSecurity_newPasswordConfirm_label: 'Confirm new password',

    account_accountSecurity_currentPasswordRequired_error: 'Please enter your current password.',
    account_accountSecurity_newPasswordRequired_error: 'Please enter a new password.',
    account_accountSecurity_newPasswordLength_error: 'The new password must be at least 8 characters long.',
    account_accountSecurity_newPasswordConfirmRequired_error: 'Please confirm the new password.',
    account_accountSecurity_passwordMismatch_error: 'The new passwords do not match.',

    account_accountSecurity_success_text: 'Your password has been changed successfully.',
    account_accountSecurity_error_text: 'The password could not be changed. Please review your input.',

    account_accountSecurity_notesPanel_header: 'Notes',
    account_accountSecurity_notesPanel_text: 'Important information about changing your password.',
    account_accountSecurity_noteOne_text: 'After a successful change, you will receive a confirmation email.',
    account_accountSecurity_noteTwo_text: 'If you no longer know your current password, use the forgot-password flow on the sign-in page.',

    // account calendar integrations
    general_refresh_button: 'Refresh',
    general_test_button: 'Test',
    general_disconnect_button: 'Disconnect',
    general_connect_button: 'Connect',

    account_accountCalendar_eyebrow_label: 'Integrations',
    account_accountCalendar_title_header: 'Calendar',
    account_accountCalendar_description_text: 'Connect external calendars and manage synchronization.',
    account_accountCalendar_back_button: 'Back to My account',

    account_accountCalendar_overview_header: 'Overview',
    account_accountCalendar_overview_text: 'Calendar integration status at a glance.',
    account_accountCalendar_overviewIntegrations_label: 'Integrations',
    account_accountCalendar_overviewSources_label: 'Selected sources',
    account_accountCalendar_overviewProviders_label: 'Providers',

    account_accountCalendar_existing_header: 'Connected calendars',
    account_accountCalendar_existing_text: 'Test, sync, or manage existing integrations.',
    account_accountCalendar_noIntegrations_text: 'There are currently no connected calendar integrations.',
    account_accountCalendar_connectedSources_text: '{{count}} connected sources',
    account_accountCalendar_lastSync_text: 'Last sync',

    account_accountCalendar_newIntegration_button: 'New integration',
    account_accountCalendar_sync_button: 'Sync',
    account_accountCalendar_manageSources_button: 'Manage sources',

    account_accountCalendar_providerSelection_header: 'Choose provider',
    account_accountCalendar_providerSelection_text: 'First choose a calendar provider, then complete the matching setup.',
    account_accountCalendar_supported_badge: 'Supported',

    account_accountCalendar_providerIcs_header: 'ICS',
    account_accountCalendar_providerIcs_text: 'Connect calendars via an ICS URL.',
    account_accountCalendar_providerIcsSetup_text: 'Enter the ICS URL and optionally provide credentials.',
    account_accountCalendar_providerIcsAbo: 'Subscribe to ICS',
    account_accountCalendar_providerIcsUpload: 'Upload ICS file',

    account_accountCalendar_providerMicrosoft_header: 'Microsoft',
    account_accountCalendar_providerMicrosoft_text: 'Connect Microsoft calendars via OAuth.',
    account_accountCalendar_providerMicrosoftSetup_text: 'Configure the Microsoft connection, then start the OAuth flow.',

    account_accountCalendar_providerGoogle_header: 'Google',
    account_accountCalendar_providerGoogle_text: 'Connect Google calendars via OAuth.',
    account_accountCalendar_providerGoogleSetup_text: 'Configure the Google connection, then start the OAuth flow.',

    account_accountCalendar_providerUnknown_label: 'Calendar provider',

    account_accountCalendar_displayName_label: 'Display name',
    account_accountCalendar_icsUrl_label: 'ICS URL',
    account_accountCalendar_icsUsername_label: 'Username',
    account_accountCalendar_icsPassword_label: 'Password',
    account_accountCalendar_tenantHint_label: 'Tenant hint',
    account_accountCalendar_oAuthClientId_label: 'OAuth client id',
    account_accountCalendar_oAuthClientSecret_label: 'OAuth client secret',

    account_accountCalendar_importAppointments_label: 'Import appointments',
    account_accountCalendar_importAbsences_label: 'Import absences',
    account_accountCalendar_exportAbsences_label: 'Export absences',

    account_accountCalendar_createIntegration_button: 'Create integration',

    account_accountCalendar_sources_header: 'Calendar sources',
    account_accountCalendar_sources_text: 'Choose which calendars should be used for this integration.',
    account_accountCalendar_noSources_text: 'No calendar sources were found.',
    account_accountCalendar_refreshSources_button: 'Refresh sources',
    account_accountCalendar_saveSources_button: 'Save selection',
    account_accountCalendar_sourcesSaved_text: 'The source selection has been saved.',
    account_accountCalendar_readOnly_label: 'Read only',
    account_accountCalendar_primary_label: 'Primary',
    account_accountCalendar_unsubscribeSource_button: 'Unsubscribe source',
    account_accountCalendar_removeSource_button: 'Remove source',

    account_accountCalendar_oAuthSuccess_text: 'The OAuth connection was completed successfully.',
    account_accountCalendar_oAuthStateMismatch_text: 'The OAuth sign in could not be verified.',
    account_accountCalendar_oAuthProviderMissing_text: 'The provider for the OAuth return could not be determined.',
    account_accountCalendar_icsCreateSuccess_text: 'The ICS integration has been created.',
    account_accountCalendar_genericError_text: 'The calendar integration could not be processed.',

    account_accountCalendar_providerIcsUploadInfo_text: 'One time ICS file import. This flow does not create a permanent calendar integration.',
    account_accountCalendar_providerIcsUploadFile_label: 'Select ICS file',
    account_accountCalendar_providerIcsUploadNoFile_text: 'No file selected yet',
    account_accountCalendar_skipDuplicates_label: 'Skip duplicates',
    account_accountCalendar_splitOverlappingEntries_label: 'Split overlapping entries',
    account_accountCalendar_dryRun_label: 'Simulate only, do not save',
    account_accountCalendar_resetSelection_button: 'Reset selection',
    account_accountCalendar_previewLoad_button: 'Load preview',
    account_accountCalendar_importExecute_button: 'Run import',
    account_accountCalendar_importFile_label: 'File',
    account_accountCalendar_importEntries_label: 'Entries',
    account_accountCalendar_importWarnings_label: 'Warnings',
    account_accountCalendar_importPreview_header: 'ICS Preview',
    account_accountCalendar_importPreview_text: 'Summary from the preview endpoint',
    account_accountCalendar_importPeriod_label: 'Period',
    account_accountCalendar_importFrom_label: 'From',
    account_accountCalendar_importTo_label: 'To',
    account_accountCalendar_importCreated_label: 'Created',
    account_accountCalendar_importUpdated_label: 'Updated',
    account_accountCalendar_importSkipped_label: 'Skipped',
    account_accountCalendar_importConflicts_label: 'Conflicts',
    account_accountCalendar_importHints_header: 'Import notes',
    account_accountCalendar_importHints_text: 'Messages returned by the commit endpoint',
    account_accountCalendar_importFileMissing_text: 'Please select an ICS file first.',
    account_accountCalendar_importPreviewSuccess_text: 'ICS preview loaded successfully.',
    account_accountCalendar_importCommitSuccess_text: 'ICS file imported successfully.',
    account_accountCalendar_importDryRunSuccess_text: 'ICS import dry run completed successfully.',

    // administration page
    administration_eyebrow_label: 'Administration',
    administration_title_header: 'Administration',
    administration_description_text: 'Central overview for account data, access control, server settings, variables and integrations.',
    administration_back_button: 'Back to dashboard',

    administration_sectionsStat_label: 'Sections',
    administration_sectionsStat_hint: 'Available administration areas',
    administration_routesStat_label: 'Destinations',
    administration_routesStat_value: '{{count}} entries',
    administration_routesStat_hint: 'Directly available administration pages',
    administration_comingSoonStat_label: 'Planned',
    administration_comingSoonStat_value: '{{count}} open',
    administration_comingSoonStat_hint: 'Areas prepared for future rollout',

    administration_sectionAccount_text: 'Manage master data, addresses and payment information.',
    administration_sectionDiagnostics_text: 'System health, logs and future monitoring areas.',
    administration_sectionAccess_text: 'Control roles, permissions and user assignments.',
    administration_sectionServer_text: 'Environment and database related server settings.',
    administration_sectionVariables_text: 'Manage system wide variables and configuration.',
    administration_sectionIntegrations_text: 'Connect external systems and communication channels.',

    administration_company_text: 'Company master data and account information.',
    administration_addresses_text: 'Manage office, billing and contact addresses.',
    administration_payment_text: 'Edit payment methods and billing information.',

    administration_logs_label: 'Logs',
    administration_logs_text: 'Protocol output, events and technical error details.',
    administration_health_label: 'Health',
    administration_health_text: 'Overview of system health and availability.',
    administration_stats_label: 'Statistics',
    administration_stats_text: 'Server metrics, usage and diagnostic values.',

    administration_roles_text: 'Define and manage roles.',
    administration_permissions_text: 'Manage permissions and role assignments.',
    administration_userRoles_text: 'Coordinate users, roles and responsibilities.',
    administration_api_label: 'API',
    administration_api_text: 'Technical interfaces and access tokens.',

    administration_environment_text: 'Review environment values and technical configuration.',
    administration_backup_text: 'Backup, restore and database operations.',
    administration_variables_text: 'Manage global system variables.',
    administration_mailClients_label: 'Email clients',
    administration_mailClients_text: 'Configure mail integrations and delivery channels.',

    "company_oauthSettings_title_header": "OAuth settings",
    "company_oauthSettings_description_text": "Manage company level OAuth settings for Google and Microsoft",

    "company_oauthSettings_providerGoogle_header": "Google Calendar",
    "company_oauthSettings_providerGoogle_text": "OAuth settings for Google Calendar connections",
    "company_oauthSettings_providerGoogle_hint": "These values are used as company defaults for Google Calendar integrations.",

    "company_oauthSettings_providerMicrosoft_header": "Microsoft 365 Calendar",
    "company_oauthSettings_providerMicrosoft_text": "OAuth settings for Microsoft 365 Calendar connections",
    "company_oauthSettings_providerMicrosoft_hint": "These values are used as company defaults for Microsoft calendar integrations.",

    "company_oauthSettings_enabled_label": "Provider enabled",
    "company_oauthSettings_allowOverride_label": "Allow user override",

    "company_oauthSettings_tenant_label": "Tenant or tenant hint",
    "company_oauthSettings_tenant_placeholder": "for example common or tenant id",

    "company_oauthSettings_clientId_label": "Client ID",
    "company_oauthSettings_clientId_placeholder": "OAuth client ID",

    "company_oauthSettings_clientSecret_label": "Client secret",
    "company_oauthSettings_clientSecret_placeholder": "OAuth client secret",
    "company_oauthSettings_clientSecretKeep_placeholder": "Leave empty to keep the existing secret",

    "company_oauthSettings_redirectUri_label": "Redirect URI",
    "company_oauthSettings_redirectUri_placeholder": "https://app.example.com/oauth/callback",

    "administration_oauthSettings_label": "OAuth settings",
    "administration_oauthSettings_text": "Manage Google and Microsoft OAuth configuration for integrations"


}